var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ym-page"},[_c('search-form',{attrs:{"form":_vm.form},on:{"search":_vm.search}}),_c('table-list',{attrs:{"datas":_vm.searchVal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }